import React from 'react';
import MedicationLandingPage from '../components/MedicationLandingPage';

const data = {
  slug: 'valtoco',
  etsyUrl: 'https://www.etsy.com/shop/MyGuardPod?ref=seller-platform-mcnav&section_id=57806717',
  en: {
    title: 'ValtoPod Protective Carrying Case',
    subtitle: 'Purpose-built carrying case format designed to fit the Valtoco\u00ae (diazepam nasal spray) container and supplies.',
    aboutTitle: 'About Valtoco\u00ae',
    aboutText: 'Valtoco\u00ae is a prescription nasal spray containing diazepam, prescribed as a rescue treatment for seizure clusters in people with epilepsy. Product information, indications, dosage and administration instructions are established by the medication manufacturer and by the user\u2019s healthcare professional.',
    whyTitle: 'Why a fitted carrying case',
    whyText: 'Rescue nasal spray containers are often carried loose in bags, pockets or backpacks. A fitted carrying case can help keep the container organized, visible and identified during everyday carry.',
    whyPoints: [
      'Format-specific organization',
      'Highly visible identification',
      'Fitted layout for the specific listed medication format',
      'Added physical barrier during everyday carry',
      'Quick-opening carrying-case design',
      'Made to order in Qu\u00e9bec, Canada',
      'Medication and medical supplies not included',
    ],
    howTitle: 'What the ValtoPod is',
    howText: 'The ValtoPod is a protective carrying case format designed to contain, organize, identify and transport a Valtoco\u00ae nasal spray container. It does not administer, dose, monitor, preserve or modify the medication.',
    ctaTitle: 'Get your ValtoPod',
  },
  fr: {
    title: '\u00c9tui protecteur ValtoPod',
    subtitle: 'Format d\u2019\u00e9tui de transport con\u00e7u pour accueillir le contenant de Valtoco\u00ae (diaz\u00e9pam en vaporisateur nasal) et son mat\u00e9riel.',
    aboutTitle: '\u00c0 propos de Valtoco\u00ae',
    aboutText: 'Valtoco\u00ae est un vaporisateur nasal de diaz\u00e9pam prescrit comme traitement de secours pour les crises \u00e9pileptiques en grappe. Les renseignements sur le produit, les indications, la posologie et les instructions d\u2019administration sont \u00e9tablis par le fabricant du m\u00e9dicament et par le professionnel de la sant\u00e9 de l\u2019utilisateur.',
    whyTitle: 'Pourquoi un \u00e9tui ajust\u00e9',
    whyText: 'Les contenants de vaporisateurs de secours sont souvent transport\u00e9s libres dans des sacs, poches ou sacs \u00e0 dos. Un \u00e9tui ajust\u00e9 peut aider \u00e0 garder le contenant organis\u00e9, visible et identifi\u00e9 pendant le transport quotidien.',
    whyPoints: [
      'Organisation adapt\u00e9e au format',
      'Identification tr\u00e8s visible',
      'Am\u00e9nagement ajust\u00e9 au format de m\u00e9dicament indiqu\u00e9',
      'Barri\u00e8re physique ajout\u00e9e pendant le transport quotidien',
      'Ouverture rapide de l\u2019\u00e9tui',
      'Fabriqu\u00e9 sur commande au Qu\u00e9bec, Canada',
      'M\u00e9dicament et mat\u00e9riel m\u00e9dical non inclus',
    ],
    howTitle: 'Qu\u2019est-ce que le ValtoPod',
    howText: 'Le ValtoPod est un format d\u2019\u00e9tui de transport protecteur con\u00e7u pour contenir, organiser, identifier et transporter un contenant de Valtoco\u00ae. Il n\u2019administre, ne dose, ne surveille, ne conserve et ne modifie aucun m\u00e9dicament.',
    ctaTitle: 'Obtenez votre ValtoPod',
  },
};

const ValtocoCasePage = () => <MedicationLandingPage medication={data} />;
export default ValtocoCasePage;
